import { Clock, LoaderCircle, CircleSlash2 } from 'lucide-react';
import { cn } from 'utils/utils';

export type InvoiceStatus = 'aguardando' | 'processando' | 'recusado';

export type InvoiceStatusIconProps = {
  status: InvoiceStatus;
  size?: 'small' | 'large';
};

type StatusBaseProps = {
  children: React.ReactNode;
} & React.HTMLAttributes<HTMLSpanElement>;

export function InvoiceStatusIcon({ status, size }: InvoiceStatusIconProps) {
  const StatusBase = ({ children, className }: StatusBaseProps) => {
    return (
      <span
        title={status.toUpperCase()}
        className={cn(
          'rounded-full bg-slate-300 text-slate-50 flex items-center justify-center p-1',
          size === 'large' ? 'w-10 h-10' : 'w-8 h-8',
          className
        )}
      >
        {children}
      </span>
    );
  };
  const renderIcon = (status: InvoiceStatus) => {
    switch (status) {
      case 'aguardando':
        return (
          <StatusBase className="bg-blue-500">
            <Clock />
          </StatusBase>
        );
      case 'processando':
        return (
          <StatusBase className="bg-orange-500">
            <LoaderCircle />
          </StatusBase>
        );
      case 'recusado':
        return (
          <StatusBase className="bg-red-500">
            <CircleSlash2 />
          </StatusBase>
        );
      default:
        return (
          <StatusBase>
            <></>
          </StatusBase>
        );
    }
  };
  return (
    <div className="flex items-center justify-center">{renderIcon(status)}</div>
  );
}
